(() => {
  const init = root => {
    if (root.dataset.editorialReady) return;
    root.dataset.editorialReady = 'true';
    const q = s => root.querySelector(s), all = s => [...root.querySelectorAll(s)];
    const track = q('[data-gallery]'), slides = all('.tlf-slide'), thumbs = all('[data-thumb]');
    const stage = q('.tle-gallery-stage');
    // Keep the shared gallery controller's hook without showing photo disclaimers.
    const caption = q('[data-photo-caption]');
    if (caption) {
      caption.hidden = true;
      const clearCaption = () => { if (caption.textContent) caption.textContent = ''; };
      new MutationObserver(clearCaption).observe(caption, {childList: true, characterData: true, subtree: true});
      clearCaption();
    }

    const index = () => Math.max(0, Math.min(slides.length - 1, Math.round(track.scrollLeft / track.clientWidth)));
    const go = n => thumbs[Math.max(0, Math.min(slides.length - 1, n))]?.click();
    const fitGallery = () => {
      // Resize after navigation settles so the shared controller keeps its target.
      const photo = slides[index()]?.querySelector('img');
      if (stage && photo?.naturalWidth && photo?.naturalHeight) {
        const ratio = `${photo.naturalWidth} / ${photo.naturalHeight}`;
        if (stage.style.aspectRatio !== ratio) stage.style.aspectRatio = ratio;
      }
    };
    let fitTimer;
    const scheduleFit = () => {
      clearTimeout(fitTimer);
      fitTimer = setTimeout(fitGallery, 180);
    };
    const syncGallery = () => {
      const n = index();
      q('[data-photo-count]').textContent = `${n + 1} / ${slides.length}`;
      q('[data-photo-prev]').disabled = n === 0;
      q('[data-photo-next]').disabled = n === slides.length - 1;
      q('.tlf-thumbs').style.maxHeight = matchMedia('(min-width: 750px)').matches ? `${track.clientHeight}px` : 'none';
    };
    q('[data-photo-prev]').addEventListener('click', () => go(index() - 1));
    q('[data-photo-next]').addEventListener('click', () => go(index() + 1));
    q('[data-photo-zoom]').addEventListener('click', () => slides[index()].querySelector('[data-enlarge]').click());
    track.addEventListener('scroll', () => { syncGallery(); scheduleFit(); }, {passive: true});
    slides.forEach(slide => slide.querySelector('img')?.addEventListener('load', scheduleFit));
    new ResizeObserver(syncGallery).observe(track);
    const variants = JSON.parse(q('[data-variants]').textContent);
    const syncName = () => {
      const first = q('[data-size="0"]'), variant = variants.find(v => String(v.id) === first.value);
      q('[data-selected-color-name]').textContent = variant?.name || first.selectedOptions[0].textContent;
    };
    all('[data-color]').forEach(b => b.addEventListener('click', syncName));
    all('[data-size], [data-bundle]').forEach(e => e.addEventListener('change', syncName));
    window.addEventListener('pageshow', syncName);
    const questions = all('[data-faq-question]'), groups = all('[data-faq-group]');
    q('[data-faq-search]').addEventListener('input', event => {
      const term = event.target.value.trim().toLocaleLowerCase();
      let shown = 0;
      questions.forEach(d => {
        const match = !term || d.textContent.toLocaleLowerCase().includes(term);
        d.hidden = !match;
        if (match) shown++;
      });
      groups.forEach(g => g.hidden = ![...g.querySelectorAll('[data-faq-question]')].some(d => !d.hidden));
      q('[data-faq-result]').textContent = term ? `${shown} matching question${shown === 1 ? '' : 's'}` : `${questions.length} product questions`;
    });
    all('.tle-jump-nav a').forEach(a => a.addEventListener('click', () => {
      const target = q(a.getAttribute('href'));
      if (target?.tagName === 'DETAILS') target.open = true;
    }));
    syncName(); syncGallery(); fitGallery();
  };
  document.querySelectorAll('.tl-editorial').forEach(init);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('.tl-editorial').forEach(init));
})();
